import React, { useEffect, useState, useContext } from "react";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { DialogContentText, Divider } from "@mui/material";
import { Snackbar } from '@mui/material';
import { FormControl, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { WarningOutlined } from '@mui/icons-material';
import { Link,useNavigate} from 'react-router-dom';
import { UserContext } from "../../../context/UserContext"
import { BASE_URL } from "../../../baseUrl"

const SignatorySubscriptionModal = (props) => {

  const options = [
    { 
      label: 'Signatory User', 
      description: 'A Signatory user can create, edit, and report progress. This is commonly (but not exclusively) a public-sector user part of a city or community. Please click and insert the requested keys below:', 
      keyTypes: [
        { type: 0, label: 'STEP1: Insert Signatory Key', description: 'This was provided by the Dashboard 2050 team when you filled the form as "Public Sector" User.' },
        { type: 1, label: 'STEP2: Paste Encrypted Key', description: 'After submitting the Signatory key, come back here and insert the key received by email' }
      ]
    },
    { 
      label: 'Corporate Signatory', 
      description: 'A Corporate Signatory can connect with various Signatories, and view Signatory data. This can be a private-sector user that wants to help a city or community. Please click and insert the requested keys below:', 
      keyTypes: [
        { type: 2, label: 'STEP1: Insert Corporate Key', description: 'This was provided by the Dashboard 2050 team when you filled the form as "Private or Other Sector" User.' },
        { type: 3, label: 'STEP2: Paste Corporate Encrypted Key', description: 'After submitting the Corporate Key, come back here and insert the key received by email' }
      ]
    },
    { 
      label: 'Request Access to Signatory Data', 
      description: 'This option is for users that want to view, edit, and modify Strategy Data granted by a Signatory.', 
      keyTypes: [
        { type: 4, label: 'STEP1: Insert Account Number to request connection', description: 'This will send a request to the Signatory you are trying to connect your account to. The Signatory can provide you with their Account Number if you do not have it' },
        { type: 5, label: 'STEP2: Paste Encrypted Authorization Key', description: 'After the Signatory approves your request, come back here and insert the key to confirm the link between the signatory account and your account (key sent by email)' }
      ]
    }
  ];

  const urlMap = {
    0: "/api/signatory_key/request/",
    1: "/api/signatory_key/confirmed/",
    2: "/api/corp_key/request/",
    3: "/api/corp_key/confirmed/",
    4: "/api/corp_key/request/external/",
    5: "/api/corp_key/request/external/response/"
    // Add other types and URLs as needed
  };

  const MsgSnack = {
    0: 'Please check your email for the Encrypted Key, then proceed to Step 2',
    1: "",
    2: 'Please check your email for the Encrypted Key, then proceed to Step 2',
    3: "",
    4: 'Please check your email for the Encrypted Key, then proceed to Step 2',
    5: ""
    // Add other types and URLs as needed
  }

  const [login, setLogin] = useContext(UserContext);
  const { onClose, value: valueProp, open, token:tokenProp, userid:useridProp, ...other } = props;
  const [value, setValue] = useState(null);
  const [key, setKey] = useState("");
  const [selectedKey, setSelectedKey] = useState(null);
  // State for Snackbar visibility and message
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setValue(valueProp);
  }, [valueProp]);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    setKey("");
    setSelectedKey(null); // Reset selected key when tab changes
  };

  const handleCancel = () => {
    onClose();
  };

  // Function to close Snackbar
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleUpdateSignatory = async (e) => {
    e.preventDefault();
    let type
    let url_api
    let msg
    
    if (login.category === 2) {
      type = options[2].keyTypes[selectedKey].type
    }else{
      type = options[value].keyTypes[selectedKey].type;
    }

    url_api = urlMap.hasOwnProperty(type) ? urlMap[type] : "URL_for_unhandled_type";
    msg = MsgSnack.hasOwnProperty(type) ? MsgSnack[type] : "Msg_snackbar";
    
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + tokenProp
      },
      body: JSON.stringify({Key:key})
    }
    let response;

    try {
      if (selectedKey !== null) {
          //response = await fetch(`/api/signatory_key/${options[value].keyTypes[selectedKey].type}`, requestOptions);
          response = await fetch( BASE_URL + url_api, requestOptions);
  
        }

      if (!response.ok) {
          // Convert non-2xx HTTP responses into errors
          const error = new Error('An error occurred while fetching the data.');
          // You might want to include more error information here, like status code or response body
          error.info = await response.json(); // or response.text() if your server sends non-JSON data
          error.status = response.status;
          setSnackbarMessage('An error occurred while fetching the data.');
          setSnackbarOpen(true);
          throw error;
      }

       //navigate('/');
      if (msg !== '') {
        setSnackbarMessage(msg);
        setSnackbarOpen(true);
      } else {
          // Handle successful response
          handleCancel(); // Assuming handleCancel is your success handler
          navigate('/');
      }   

    } catch (error) {
      // Handle or log error
      console.error('Error:', error.message); // Basic error handling, you can expand this as needed
      setSnackbarMessage(error.message);
      setSnackbarOpen(true);
    }
  }

  return (
  <>
    <Dialog
    sx={{ '& .MuiDialog-paper': { width: '75%', maxWidth: '600px', display:'flex' } }} // Adjust the width here
      
    maxWidth='sm'
      open={open}
      {...other}
    >
      {login.category === 2 ? (
        
        <>
          <DialogTitle>Request permission to access Signatory data</DialogTitle>
          <DialogContent dividers>
  
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} textAlign='left'>
                  <DialogContentText width='90%' sx={{ marginBottom: '1rem', marginTop: '1rem' }}>
                    {options[2].description}
                  </DialogContentText>
                  <FormControl component="fieldset">
                  <RadioGroup value={selectedKey} onChange={(e) => setSelectedKey(parseInt(e.target.value))}>
                    {options[2]?.keyTypes.map((keyType, index) => (
                      <FormControlLabel
                        key={index}
                        value={index}
                        control={<Radio />}
                        label={
                          <div>
                          <span style={{ fontWeight: 'bold',  }}>{keyType.label}</span>
                          <br />
                          <span >{keyType.description}</span>
                          </div>
                        }
                        labelPlacement="end" 
                        sx={{marginLeft: '3rem', paddingBottom: '1rem'}}
                      />
                    ))}
                  </RadioGroup>
                  </FormControl>
                  {(selectedKey !== null && options[2]?.keyTypes[selectedKey]) && (
                    <TextField
                      required
                      id="key"
                      label={options[2].keyTypes[selectedKey].label}
                      defaultValue=""
                      fullWidth
                      onChange={(e) => setKey(e.target.value)}
                      sx={{ marginBottom: '1rem', marginTop: '1rem' }}
                    />
                  )}
                </Grid>
                
                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={6000} // Auto close after 6 seconds
                  onClose={handleCloseSnackbar}
                  message={snackbarMessage}
                  sx={{
                    top: '50%',
                    left: '50%',
                    transform: 'translate(50%, -50%)',
                    '& .MuiSnackbarContent-root': {
                      backgroundColor: 'whitesmoke', 
                      color: 'Red',
                    }}}

                />

              </Grid>
            
          </DialogContent>
        </>
      ):(
        <>
          <DialogTitle>Select the appropriate method specific to your case:</DialogTitle>
          <DialogTitle sx={{ fontSize: '1rem' }}>Pick one of the 3 options below to see more details and inform your selection:</DialogTitle>
          
          <DialogContent dividers>
          
            <Grid container justifyContent="center">
              <Tabs value={value} onChange={handleTabChange}>
                {options.map((option, index) => (
                  <Tab key={index} label={option.label} />
                ))}
              </Tabs>
            </Grid>


            {value !== null && (
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} textAlign='left'>
                  <DialogContentText width='90%' sx={{ marginBottom: '1rem', marginTop: '1rem' }}>
                    {options[value]?.description}
                  </DialogContentText>
                  <FormControl component="fieldset">
                  <RadioGroup value={selectedKey} onChange={(e) => setSelectedKey(parseInt(e.target.value))}>
                    {options[value]?.keyTypes.map((keyType, index) => (
                      <FormControlLabel
                        key={index}
                        value={index}
                        control={<Radio />}
                        label={
                          <div>
                          <span style={{ fontWeight: 'bold',  }}>{keyType.label}</span>
                          <br />
                          <span >{keyType.description}</span>
                          </div>
                        }
                        labelPlacement="end" 
                        sx={{marginLeft: '3rem', paddingBottom: '1rem'}}
                      />
                    ))}
                  </RadioGroup>
                  </FormControl>
                  {(selectedKey !== null && options[value]?.keyTypes[selectedKey]) && (
                    <TextField
                      required
                      id="key"
                      label={options[value].keyTypes[selectedKey].label}
                      defaultValue=""
                      fullWidth
                      onChange={(e) => setKey(e.target.value)}
                      sx={{ marginBottom: '1rem', marginTop: '1rem' }}
                    />
                  )}
                </Grid>
                
                <Snackbar
                  open={snackbarOpen}
                  autoHideDuration={6000} // Auto close after 6 seconds
                  onClose={handleCloseSnackbar}
                  message={snackbarMessage}
                  sx={{
                    top: '50%',
                    left: '50%',
                    transform: 'translate(50%, -50%)',
                    '& .MuiSnackbarContent-root': {
                      backgroundColor: 'whitesmoke', 
                      color: 'Red',
                    }}}

                />

              </Grid>
            )}

          </DialogContent>
        </>
      )}
      
      

      <DialogActions>
        <Button autoFocus onClick={handleCancel}>
          Cancel
        </Button>
        <Button onClick={handleUpdateSignatory}>Submit</Button>
      </DialogActions>
      
      
  
    </ Dialog>  

  </>
  

  );
}

SignatorySubscriptionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  userid: PropTypes.string.isRequired,
};

export default SignatorySubscriptionModal;
